import React, { useState } from "react";
import plus_icon_blue from "../../assets/images/plus_icon_blue.svg";
import CompanysPayrollPopup from "./CompanysPayrollPopup";

const DetailTopPart = ({ client = {}, labels = {}, buttons = {}, className = "" }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <div className={`detail_top_part mt_30 ${className}`}>
      <div className="container-fluid">
        <div className="row align-items-center">
          {/* --- Client info section --- */}
          <div className="col-md-8">
            <div className="d-flex align-items-center">
              <div className="clint_img">
                <img src={client.image} alt={client.name} />
              </div>
              <div className="content ml_40">
                <h4 className="mb_16 fs_30 fw_500 text_black">{client.name}</h4>
                <ul className="detail_list m-0">
                  <li>
                    <span>{labels.email || "Email"} :</span> {client.email}
                  </li>
                  <li className="devider_line">|</li>
                  <li>
                    <span>{labels.phone || "Phone"} :</span> {client.phone}
                  </li>
                  {/* <li className="devider_line">|</li> */}
                  {/* <li>
                    <span>{labels.address || "Address"} :</span>{" "}
                    {client.address || "N/A"}
                  </li> */}
                </ul>
                <ul className="detail_list m-0">
                  <li>
                    <span>{labels.address || "Address"} :</span>{" "}
                    {client.address || "N/A"}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* --- Right section - Buttons --- */}
          <div className="col-md-4 text-end">
            <div className="d-flex ms-auto w-100">
              {/* Add Company / Employee Button */}
              {buttons.addEmployee && (
                <button
                  className={buttons.addEmployee.className}
                  onClick={buttons.addEmployee.onClick}
                >
                  {buttons.addEmployee.showIcon && (
                    <img src={plus_icon_blue} alt="Add" />
                  )}{" "}
                  {buttons.addEmployee.text}
                </button>
              )}

              {buttons?.addCompany && (
                <button
                  className={buttons.addCompany.className}
                  onClick={buttons.addCompany.onClick}
                >
                  {buttons.addCompany.showIcon && (
                    <img src={plus_icon_blue} alt="Add" />
                  )}{" "}
                  {buttons.addCompany.text}
                </button>
              )}

              {/* Payroll Button */}
              {buttons.payroll && (
                <button
                  className={buttons.payroll.className}
                  onClick={buttons.payroll.onClick || handleShow} // if custom handler exists, use it
                >
                  {buttons.payroll.text}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Only show popup if no custom onClick is provided */}
      {buttons.payroll && !buttons.payroll.onClick && (
        <CompanysPayrollPopup show={showModal} onHide={handleClose} />
      )}
    </div>
  );
};

export default DetailTopPart;
